import React from 'react';

import { StyledAppOSCompoatibility } from './AppOSCompatibility.styles';

import { AppOSCompatibilityProps } from './AppOSCompatibility.types';

const AppOSCompatibility = ({
  label,
  osDetailsList,
  componentClassname = 'app-os-compatibility',
  customClassnames = '',
  customStyle = '',
  ...props
}: AppOSCompatibilityProps) => {
  return (
    <StyledAppOSCompoatibility
      className={`${componentClassname} ${customClassnames}`}
      customStyle={customStyle}
      {...props}
    >
      <div className={`${componentClassname}__label`}>{label}</div>
      <ul className={`${componentClassname}__slot-ul`}>
        {osDetailsList?.map(({ name, slot }) => (
          <li
            key={name}
            className={`
              ${componentClassname}__slot-li 
              ${componentClassname}__slot-li--${name}
            `}
          >
            {slot}
          </li>
        ))}
      </ul>
    </StyledAppOSCompoatibility>
  );
};
AppOSCompatibility.displayName = 'AppOSCompatibility';

export default AppOSCompatibility;
